// removed by extract-text-webpack-plugin
module.exports = {"container":"kz5LJXW9mUbQ9IpjCY_r3"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-417b5f32","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/rep-call/live-coach-chat/live-coach-chat.less
// module id = RfNV
// module chunks = 1